import UserTableFilter from './user-table-filter';

export default UserTableFilter;